import {
  FETCH_PCREPORT_LISTING_SUCCESS,
  FETCH_PCREPORT_LISTING_FAILURE,
  RESET,
} from "./pettyCashReportsTypes";

const initialState = {
  allTransactions: [],
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PCREPORT_LISTING_SUCCESS:
      return {
        allTransactions: action.payload,
        error: null,
      };
    case FETCH_PCREPORT_LISTING_FAILURE:
      return {
        allTransactions: [],
        error: action.payload,
      };
    case RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
